export default __webpack_public_path__ + "static/media/clinic-history.457e8537.png";